export default function H1({ title, fontWeight = 'bold', theme = "title", className = "" }) {
    return (
        <h1 className={`text-3xl md:text-5xl font-${fontWeight} text-${theme} ${className}`}>
            {title}
        </h1>
    );
}
